import { render, staticRenderFns } from "./CardProdutoCom298.vue?vue&type=template&id=0fc80246&"
import script from "./CardProdutoCom298.vue?vue&type=script&lang=js&"
export * from "./CardProdutoCom298.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports